import { render } from "./EatTheRainbow.vue?vue&type=template&id=8ef486a6"
import script from "./EatTheRainbow.vue?vue&type=script&lang=js"
export * from "./EatTheRainbow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__